export enum AccountCreationEnum {
	PERSONAL_DATA = 1,
	CONFIRMATION_PASSWORD = 2,
	VALIDATION_CODE = 3,
	CREATED_ACCOUNT = 4,
}
